import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import GlobalStyle from 'commons/styles/global-style'
import ToastContainerWithTheme from 'components/ToastContainerWithTheme'
import Main from 'screen/Main'

const App = () => (
  <>
    <CssBaseline />
    <GlobalStyle />
    <ToastContainerWithTheme />
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </>
)

export default App
